import styled, { withTheme } from 'styled-components'
import { lighten } from 'polished'

const OutlineButton = styled.a`
  display: inline-block;

  border: 1px solid ${(props) => props.theme.colors.white};
  border-radius: 100px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.white};
  letter-spacing: 0.8px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  padding: 10px 24px 11px;
  transition: background-color 0.5s ${(props) => props.theme.ease.ease_out_expo};
  font-weight: 600;

  &:hover {
    background-color: ${(props) => lighten(0.1, props.theme.colors.white_op30)};
    color: ${(props) => props.theme.colors.white};
  }
`

export default withTheme(OutlineButton)
